import * as Yup from 'yup';

export const AddSchema = Yup.object().shape({
  name: Yup.string().required('نام  اجباری می باشد'),
  state: Yup.string().required('استان اجباری می باشد'),
  city: Yup.string(),
  account_type: Yup.string().required('نقش کاربری اجباری می باشد'),
});
